import { forwardRef } from 'react';
import { Switch as AntdSwitch } from 'antd';

/**
 * @param {Object} props - Same shape as antd's own `Switch` (already renders as a real
 *   `role="switch"` button), forwarded as-is. Needs an accessible name: pass `aria-label` or
 *   `aria-labelledby`, since the switch itself has no visible text.
 */
const Switch = forwardRef((props, ref) => <AntdSwitch ref={ref} {...props} />);
Switch.displayName = 'Switch';

export default Switch;
